import { Component, OnInit } from '@angular/core';
import { Hydra } from 'src/app/interfaces/hydra';
import { Project } from 'src/app/interfaces/project';
import { ProjectService } from 'src/app/services/project.service';
import { ApiInit } from 'src/app/utils/api-init';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '../../components/loader/loader.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SearchItemComponent } from '../../components/search-item/search-item.component';
import { NgIf, NgFor } from '@angular/common';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ProjectStar } from '../../interfaces/project-star';
import { Suggestion } from 'src/app/interfaces/suggestion';
import { animate, style, transition, trigger } from '@angular/animations';
import { StateNoticeComponent } from '../../components/state-notice/state-notice.component';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.page.html',
  standalone: true,
  animations: [
    trigger('slideOut', [
      transition(':leave', [
        animate(
          '300ms ease',
          style({ transform: 'translateX(100%)', opacity: 0 })
        ),
      ]),
    ]),
  ],
  imports: [
    NgIf,
    NgFor,
    SearchItemComponent,
    InlineSVGModule,
    LoaderComponent,
    TranslateModule,
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    StateNoticeComponent,
  ],
})
export class ProjectsPage implements OnInit {
  projects: Project[] = [];
  suggestions: Suggestion[] = [];
  projectsLoaded: boolean = false;
  shouldReload: boolean = false;

  constructor(
    private projectService: ProjectService,
    private apiInit: ApiInit
  ) {}

  ngOnInit() {
    this.apiInit.watch(async () => {
      this.loadProjects();
    });

    this.projectService.starChanged$.subscribe((value) => {
      if (!this.projects.length && !this.suggestions.length && !value.starred) {
        this.loadSuggestions();
      }
      this.shouldReload = true;
    });
  }

  ionViewDidLeave() {
    if (this.shouldReload) {
      this.suggestions = [];
      this.loadProjects();
      this.shouldReload = false;
    }
  }

  async loadProjects() {
    try {
      const stars: ProjectStar[] =
        await this.projectService.getStarredProjects();
      this.projects = stars.map((star) => star.project);
    } catch (error) {
    } finally {
      if (!this.projects.length) {
        await this.loadSuggestions();
      }
      this.projectsLoaded = true;
    }
  }

  async loadSuggestions() {
    this.projectsLoaded = false;
    this.suggestions = await this.projectService.getProjectsByClosestLocation();
    this.projectsLoaded = true;
  }

  removeProject(slug: string) {
    this.projects.splice(
      this.projects.findIndex((project) => project.slug === slug),
      1
    );
    if (this.projects.length === 0) this.projectsLoaded = false;
  }
}
